enum Scenes {
  PreloadScene = "PreloadScene",
  MainScene = "MainScene",
  UI_levelUpScene = "UI_levelUpScene",
  GameOverScene = "GameOverScene",
  MainMenuScene = "MainMenuScene",
  TestScene = "TestScene",
  UI_treasureScene = "UI_treasureScene",
  // CharacterManagementScene = 'CharacterManagementScene',
  PauseScene = "PauseScene",
  EvolutionScene = "EvolutionScene",
}

export default Scenes;
